module.exports = __webpack_public_path__ + "assets/arrows.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrows.png
// module id = 1133
// module chunks = 7